import {appState, proposal} from "../../globalState";
import {doc, getFirestore, setDoc} from "firebase/firestore";
import getFirebase from "../../firebase";

export function uploadProposal({
                                   setLink,
                                   buildingName,
                                   columns,
                                   rideItems,
                                   logoImage,
                                   roomSimulationImage,
                                   roomSimulationImageDesc,
                                   rideSimulationImage,
                                   rideSimulationImageDesc,
                                   colorUnit,
                                   typeOfProperty,
                                   typeOfTemplate,
                                   numOfUnit,
                                   separatePrinter = false,
                                   ride,
                                   rent,
                                   shop,
                                   location,
                                   setPDFMode,
                               }) {
    return async () => {
        setLink("");

        const user = JSON.parse(localStorage.getItem("user"));
        const mail = user.providerData[0].email;
        const editors = [
            ...proposal.editors,
            {user: mail, timestamp: new Date()},
        ];

        const db = getFirestore(getFirebase());

        await setDoc(doc(db, "my_tulu", buildingName), {
            ...proposal,
            columns: JSON.stringify(columns),
            rideItems: JSON.stringify(rideItems),
            logoImage,
            roomSimulationImage,
            roomSimulationImageDesc,
            rideSimulationImage,
            rideSimulationImageDesc,
            colorUnit,
            typeOfProperty,
            typeOfTemplate,
            numOfUnit,
            buildingName,
            ride,
            rent,
            shop,
            separatePrinter,
            location,
            editors,
        });


        setPDFMode(true);
        appState.uploadStatus = "Rendering PDF...";
    };
}
